<div (mouseenter)="onSidebarOver(true)" (mouseleave)="onSidebarOver(false)">

  <div class="logo d-flex align-items-center">
    <a href="" class="simple-text">
      <div class="logo-image-small">
        <img src="../../assets/img/LogoGtex-02.svg" class="img-fluid" width="100" />
      </div>
    </a>
  </div>

  <div class="sidebar-wrapper">

    <div class="user">
      <div class="photo">
        <img src="./assets/img/faces/user.png" />
      </div>
      <div class="info">
        <a data-toggle="collapse" href="#collapseExample" class="collapsed">
          <span>
            {{userName}}
            <b class="caret"></b>
          </span>
        </a>
        <div class="clearfix"></div>
        <div class="collapse" id="collapseExample">
          <ul class="nav">
            <li>
              <a routerLink="/{{companyIdRef}}/user/forgot-password">
                <span class="sidebar-mini-icon">TS</span>
                <span class="sidebar-normal">Trocar Senha</span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <span class="sidebar-mini-icon">MP</span>
                <span class="sidebar-normal">My Profile</span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <span class="sidebar-mini-icon">EP</span>
                <span class="sidebar-normal">Edit Profile</span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <span class="sidebar-mini-icon">S</span>
                <span class="sidebar-normal">Settings</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="isNotMobileMenu()">
          <form class="navbar-form navbar-left navbar-search-form" role="search">
              <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-search"></i></span>
                  <input type="text" value="" class="form-control" placeholder="Search...">
              </div>
          </form>
          <ul class="nav nav-mobile-menu">
              <li>
                  <a href="#stats" class="dropdown-toggle btn-magnify" data-toggle="dropdown">
                      <i class="ti-panel"></i>
                      <p>Stats</p>
                  </a>
              </li>
              <li class="dropdown">
                  <a href="#notifications" class="dropdown-toggle btn-rotate" data-toggle="dropdown">
                      <i class="ti-bell"></i>
                      <span class="notification">5</span>
                      <p class="hidden-md hidden-lg">
                          Notifications
                          <b class="caret"></b>
                      </p>
                  </a>
                  <ul class="dropdown-menu">
                      <li><a href="#not1">Notification 1</a></li>
                      <li><a href="#not2">Notification 2</a></li>
                      <li><a href="#not3">Notification 3</a></li>
                      <li><a href="#not4">Notification 4</a></li>
                      <li><a href="#another">Another notification</a></li>
                  </ul>
              </li>
              <li>
                  <a class="btn-rotate">
                      <i class="ti-settings"></i>
                      <p class="hidden-md hidden-lg">
                          Settings
                      </p>
                  </a>
              </li>
          </ul>
      </div> -->
    <div id="accordion">
      <ul class="nav">
        <li routerLinkActive="active" *ngFor="let menuItem of menuItems" [hidden]="!menuItem.hasPermission">
          <a routerLink="/{{companyIdRef}}/{{menuItem.path}}" *ngIf="menuItem.type === 'link'" style="height: 50px;">
            <i class="{{menuItem.icontype}}"></i>
            <p *ngIf="shouldShowitens">{{menuItem.title}}</p>
          </a>

          <a role="button" href="#{{menuItem.collapse}}" data-toggle="collapse"
            [attr.data-target]="'#' + menuItem.collapse" aria-expanded="false" aria-controls="{{menuItem.collapse}}"
            *ngIf="menuItem.type === 'sub'" style="height: 50px">
            <i class="{{menuItem.icontype}}"></i>
            <p *ngIf="shouldShowitens ">{{menuItem.title}}<b class="caret"></b></p>
          </a>

          <div id="{{menuItem.collapse}}" class="collapse" data-parent="#accordion" *ngIf="menuItem.type === 'sub'">
            <ul class="nav">
              <li routerLinkActive="active" *ngFor="let childitem of menuItem.children">
                <a routerLink="/{{companyIdRef}}/{{childitem.path}}" style="height: 30px;"
                  [hidden]="!childitem.hasPermission">
                  <span class="sidebar-mini-icon">{{childitem.ab}}</span>
                  <span class="sidebar-normal" *ngIf="shouldShowitens">{{childitem.title}}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>